import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "./Pages/AppLayout";
import { ThemeProvider } from "./APIHelpers/ThemeContext";
import Login from "./AuthPage/Login";
import Signup from "./AuthPage/Signup";
import ForgetPasswordSteps from "./AuthPage/ForgetPassword";
import { useState } from "react";
import { Permission } from "./PermissionRoute";
import NotFoundPage from "./Pages/RestrictedPages/NotFoundPage";

function App() {
  const [email, setEmail] = useState("");
  const { LoginPermission, AllPermission } = Permission;
  return (
    <>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<LoginPermission />}>
              <Route path="/" element={<Login email={email} setEmail={setEmail} />} />
              <Route path="/login" element={<Login email={email} setEmail={setEmail} />} />
              <Route path="/signup" element={<Signup email={email} setEmail={setEmail} />} />
              <Route path="/signup/:token" element={<Signup email={email} setEmail={setEmail} />} />
              <Route path="/forget-password" element={<ForgetPasswordSteps />} />
            </Route>
            <Route element={<AllPermission />}>
              <Route path="/:slug/*" element={<AppLayout />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
